import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CACHED_USER_KEY } from 'utils/appConstants';
import { refreshAuthenticatedUserInfo } from 'reducers/auth/actions';
const IsAuthenticated = (AuthenticatedComponent, UnauthenticatedComponent) => {
  const IsAuthenticatedComponent = props => {
    const dispatch = useDispatch();
    const authenticatedUser = useSelector(
      state => state.auth.authenticatedUser
    );

    useEffect(() => {
      if (!authenticatedUser) {
        const cachedAuthenticatedUser = localStorage.getItem(CACHED_USER_KEY);
        if (cachedAuthenticatedUser) {
          dispatch(refreshAuthenticatedUserInfo(cachedAuthenticatedUser));
        }
      }
    }, [authenticatedUser, dispatch]);
    return (
      <React.Fragment>
        {authenticatedUser ? (
          <AuthenticatedComponent {...props} />
        ) : UnauthenticatedComponent ? (
          <UnauthenticatedComponent {...props} />
        ) : null}
      </React.Fragment>
    );
  };

  return IsAuthenticatedComponent;
};
export default IsAuthenticated;
